import React, { useState } from "react";
import "./dashboard.css"; // reuse your dashboard styling

function MondayIntegration() {
  const [apiKey, setApiKey] = useState("");
  const [status, setStatus] = useState("Not Connected");

  const connectMonday = () => {
    if (!apiKey) return alert("Enter your API Key");
    setStatus("Connected");
  };

  return (
    <div className="page-container">
      <h2 className="page-title">Monday.com Integration</h2>

      <div className="card">
        <h3>Automation Setup</h3>
        <p className="subtext">
          Connect your dashboard to Monday.com to automate tasks, track projects, and sync workflows.
        </p>

        <input
          type="text"
          placeholder="Enter Monday.com API Key"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          className="integration-input"
        />

        <button className="primary-btn" onClick={connectMonday}>
          Connect
        </button>

        <div className="integration-status">
          <h4>Status:</h4>
          <span className={status === "Connected" ? "connected" : "disconnected"}>
            {status}
          </span>
        </div>
      </div>

      <div className="card">
        <h3>Connected Workflows</h3>
        <ul className="workflow-list">
          <li>New Wallet → Create Item on Monday.com Board</li>
          <li>Activity Heatmap → Update Monday.com Dashboard</li>
          <li>Transactions → Sync with Project Board</li>
        </ul>
      </div>
    </div>
  );
}

export default MondayIntegration;
